import { Stocks } from "features/Stocks/Stocks";
import { NewShop } from "features/NewShop/NewShop";

import styles from "./styles.module.scss";

export const StocksPage = (): JSX.Element => (
  <div className={styles.main}>
    <Stocks />
    <NewShop />
  </div>
);
